module.exports = __webpack_public_path__ + "img/Create claim.b1bd26ba.jpg";